import {
  GET_TERMSCONDITION,
  GET_TERMSCONDITION_BY_ID,
} from "../constants/index";

export const termsandcondition = (
  state = { termsandconditionlist: [], termsandconditionbyid: {} },
  action,
) => {
  switch (action.type) {
    case GET_TERMSCONDITION:
      return { ...state, termsandconditionlist: action.termsandconditionlist };
    case GET_TERMSCONDITION_BY_ID:
      return { ...state, termsandconditionbyid: action.termsandconditionbyid };
    default:
      return state;
  }
};
